module.exports = __webpack_public_path__ + "static/img/wll.2dc0323.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/vipnotifyProject/images/wll.jpg
// module id = YPgl
// module chunks = 6